import React from "react";
import { MapPin, ExternalLink } from "lucide-react";
import { TextMessage, LocationMetadata } from "../../../types/chat";
import styles from "./LocationMessage.module.scss";

interface LocationMessageProps {
  message: TextMessage;
  metadata: LocationMetadata;
  isOwnMessage?: boolean;
}

const LocationMessage: React.FC<LocationMessageProps> = ({ message, metadata }) => {
  const googleMapsUrl = `https://www.google.com/maps?q=${metadata.lat},${metadata.long}`;

  return (
    <div className={styles.locationMessage}>
      <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer" className={styles.locationCard}>
        <MapPin className={styles.locationIcon} size={32} />
        <div className={styles.locationInfo}>
          <div className={styles.locationAddress}>{metadata.address}</div>
          <div className={styles.locationCoords}>
            {metadata.lat}, {metadata.long}
          </div>
        </div>
        <ExternalLink className={styles.openMapIcon} size={20} />
      </a>
    </div>
  );
};

export default LocationMessage;
